module.exports = __webpack_public_path__ + "static/img/img_cabinet.d061cf58.png";